



































































































































































































































































































































































































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import {
  GetTicketAttrsOptionReq,
  GetTicketAssignParamReq,
  GetTicketAssignRulesReq,
  SaveTicketAssignRuleReq,
  DeleteTicketAssignRuleReq,
  GetLoadAttrsOptionReq,
  TicketAssignRuleAttr,
  AttrItem,
  GetUserAttrsOptionReq,
} from "@/pbjs/external/ticket/ticket_pb";
import { ticketClient, authorClient } from "@/api/index";
import { timeFormat, addZero, arrRemove } from "@/utils/index.ts";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, errorMsg, setPage } from "@/utils/request";
import { downloadFile } from "@/utils/index";

@Component({
  name: "CombinationProperty",
})
export default class CombinationProperty extends Vue {
  @Provide() private showDialogType: number = 0;
  @Provide() private rolenames: string = "";
  @Provide() private rule_id: string = "";
  @Provide() private ruleForm: any = {
    createTimeRange: [],
  };
  @Provide() private tryCalcData: any = {
    total: "",
    remain: "",
  };
  @Provide() private tryCalcList: any = [];
  @Provide() private isTryCalcDone: boolean = false;
  @Provide() private filterText: string = "";
  @Provide() private resultData: any = [];
  @Provide() private systemtype: number = 0;
  @Provide() private token: any = "";
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private sortticketList: any = [];
  @Provide() private sortadminList: any = [];
  @Provide() private assignmodeList: any = [];
  @Provide() private combOptions: any = [];
  @Provide() private AistatusOptions: any = [
    { id: "1", val: "dashbordDy.Notinspected" },
    { id: "2", val: "dashbordDy.Qualityinspected" },
  ];
  @Provide() private loadAttrList: any = [];
  @Provide() private roleGroupList: any = [];
  @Provide() private roleGroupNewList: any = [];
  @Provide() private txt: any = this.$t;
  @Provide() private IsFinalList: any = [
    {
      value: 1,
      name: "v0707.Yes",
    },
    {
      value: 0,
      name: "v0707.No",
    },
  ];
  @Provide() private WorkDayList: any = [
    {
      value: "1",
      key: "WorkDayList1",
      name: "Mon to Fri",
    },
    {
      value: "2",
      key: "WorkDayList2",
      name: "Weekend",
    },
  ];
  @Provide() private timeOptions: string[] = ["时间点", "时间段"];
  @Provide() private actionOptions: any = [];
  @Provide() private WorkModeOptions: any = [];
  @Provide() private showTimeType: string = "";
  @Provide() private userId: any;
  @Provide() private isEditId: number = 0;
  @Provide() private isEditName: boolean = false;
  @Provide() private attr: any;
  @Provide() private form: any = {
    moment: "",
    period: [new Date(2020, 6, 1, 0, 0), new Date(2020, 6, 1, 23, 59)],
    actionValue: "",
    assignModeValue: "",
    sortAdminValue: "",
    sortTicketValue: [],
    combValue: [],
    loadAttrValue: [],
    name: "",
    IsFinal: "",
    WorkDay: "",
    roleGroupValue: [],
    roleGroupNewValue: [],
    // Aistatus: "",
    // Aiscorerange1: "",
    // Aiscorerange2: "",
  };
  @Provide() private isGetTicketAssignRulesActionDone: boolean = false;
  @Provide() private pagnition: any = pagnition;

  private created() {
    this.token = localStorage.getItem("token");
    this.userId = localStorage.getItem("userid");
    this.getTicketAssignParam();
    this.getTicketAttrsOption();
    this.getLoadAttrsOption();
    this.getTicketAssignRulesAction();
    this.getUserAttrsOption();
    this.listRole();
  }

  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getTicketAssignRules();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getTicketAssignRules();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getTicketAssignRules();
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getTicketAssignRules();
  }

  private getTicketAssignRulesAction() {
    this.isGetTicketAssignRulesActionDone = true;
    this.pageIndex = 1;
    this.getTicketAssignRules();
  }
  private editName() {
    this.isEditName = true;
  }

  private editDistributeItem(row: any) {
    this.resetForm();
    this.isEditId = row.id;
    this.form.name = row.attrs.name;
    if (this.form.name) {
      this.isEditName = true;
    }
    this.form.assignModeValue =
      row.attrs.assignmodeList && row.attrs.assignmodeList[0];
    this.form.sortAdminValue =
      row.attrs.sortadminList && row.attrs.sortadminList[0];
    this.form.sortTicketValue = row.attrs.sortticketList;
    this.form.combValue = row.attrs.ticketattrList;
    this.form.loadAttrValue = row.attrs.loadattrList;
    this.form.roleGroupValue = row.attrs.adminattrList;
    this.form.roleGroupNewValue = row.attrs.userattrList;
    this.form.IsFinal = row.attrs.isfinal;
    this.form.WorkDay = row.attrs.workday;
    if (row.attrs.assigntime) {
      this.showTimeType = "时间点";
      let time = row.attrs.assigntime.split(":");
      this.form.moment = new Date(2020, 6, 1, Number(time[0]), Number(time[1]));
    }
    if (row.attrs.begintime) {
      this.showTimeType = "时间段";
      let start = row.attrs.begintime.split(":");
      let end = row.attrs.endtime.split(":");
      this.form.period = [
        new Date(2020, 6, 1, Number(start[0]), Number(start[1])),
        new Date(2020, 6, 1, Number(end[0]), Number(end[1])),
      ];
      if (row.attrs.timeaction) {
        this.form.actionValue = row.attrs.timeaction + "";
      }
    }
  }

  private listRole() {
    let request: any = setCommon();
    authorClient.listRole(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (data.commonout) {
          if (data.commonout.code == 0) {
            this.roleGroupList = data.roletreeList;
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        } else {
          if (data.code == 0) {
            this.roleGroupList = data.roletreeList;
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private resetForm() {
    const ref: any = this.$refs["form"];
    ref.resetFields();
    this.form.moment = "";
    this.form.period = [
      new Date(2020, 6, 1, 0, 0),
      new Date(2020, 6, 1, 23, 59),
    ];
    this.showTimeType = "";
    this.form.name = "";
    this.form.WorkDay = "";
  }
  // lin 获取工单分配支持的所有的参数数据
  private async getTicketAssignParam() {
    let _arg: any = {
      systemType: 0,
    };
    const { getTicketAssignParam }: any = await import(
      "@/request/getTicketAssign"
    );
    let res = await getTicketAssignParam(_arg);
    if (res && res.param) {
      this.sortticketList = res.param.sortticketList;
      this.sortadminList = res.param.sortadminList;
      this.assignmodeList = res.param.assignmodeList;
      this.actionOptions = res.param.timeactionList;
      this.WorkModeOptions = res.param.workmodeList;
      //                 // this.roleGroupNewList = data.param.adminfilterList;
    }
  }

  private getTicketAssignRules() {
    let request: any = new GetTicketAssignRulesReq();
    request.setCommonin(setCommon());
    request.setPagein(setPage(this.pageIndex, this.pageSize));
    request.setName(this.filterText);
    ticketClient.getTicketAssignRules(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          if (!data.commonout || data.commonout.code == 0) {
            this.pagerCount = data.pageout.total;
            data.listList.forEach((item: any) => {
              item.utime = timeFormat(item.utime);
            });
            this.resultData = data.listList;
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        }
        if (err) {
          errorMsg(err);
        }
        this.isGetTicketAssignRulesActionDone = false;
      }
    );
  }
  // 获取工单组合属性下拉选项
  private getTicketAttrsOption() {
    let request: any = new GetTicketAttrsOptionReq();
    request.setCommonin(setCommon());
    request.setSystemtype(this.systemtype);
    ticketClient.getTicketAttrsOption(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          if (!data.commonout || data.commonout.code == 0) {
            this.combOptions = data.listList;
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }

  private getLoadAttrsOption() {
    let request: any = new GetLoadAttrsOptionReq();
    request.setCommonin(setCommon());
    ticketClient.getLoadAttrsOption(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          this.loadAttrList = data.listList;
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private getUserAttrsOption() {
    let request: any = new GetUserAttrsOptionReq();
    request.setCommonin(setCommon());
    ticketClient.getUserAttrsOption(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          this.roleGroupNewList = data.listList;
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  // private saveTicketAssignRule() {
  //     let moment = this.form.moment && (this.form.moment.getHours() + ":" + this.form.moment.getMinutes());
  //     let request:any = new SaveTicketAssignRuleReq();
  //     let saveItem:any = new SaveTicketAssignRuleItem();
  //     this.attr = new TicketAssignRuleAttr();
  //     this.setAttrItem(this.assignmodeList, this.form.assignModeValue, "addAssignmode");
  //     this.setAttrItem(this.sortadminList, this.form.sortAdminValue, "addSortadmin");
  //     this.setAttrItem(this.combOptions, this.form.combValue, "addTicketattr");
  //     this.setAttrItem(this.loadAttrList, this.form.loadAttrValue, "addLoadattr");
  //     this.setAttrItem(this.sortticketList, this.form.sortTicketValue, "addSortticket");
  //     if (this.showTimeType == '时间点') {
  //         this.attr.setAssigntime(this.formatTime(this.form.moment));
  //     }
  //     if (this.showTimeType == '时间段') {
  //         this.attr.setBegintime(this.form.period && this.formatTime(this.form.period[0]));
  //         this.attr.setEndtime(this.form.period && this.formatTime(this.form.period[1]));
  //         this.attr.setTimeaction(Number(this.form.actionValue));
  //     }
  //     this.attr.setName(this.form.name);
  //     saveItem.setAttrs(this.attr);
  //     request.setTrackid("");
  //     request.setClientid("");
  //     request.setToken(this.token);
  //     request.setId(this.isEditId);
  //     request.setAdminuid(this.userId);
  //     request.setData(saveItem);
  //     ticketClient.saveTicketAssignRule(request, {}, (err: any, response:any) => {
  //         if(response) {
  //             let data:any = response.toObject();
  //             if (!data.commonout || (data.commonout.code == 0)) {
  //                 this.isEditName = false;
  //                 this.isEditId = 0;
  //                 this.resetForm();
  //                 this.getTicketAssignRules();
  //                 this.$message({
  //                     message: '提交成功',
  //                     type: 'success'
  //                 });
  //             } else if (data.code == 100100 || data.code == 100101) {
  //                 this.$router.push("./login");
  //             } else {
  //                 this.$message.error(data.commonout.errmsg);
  //             }
  //         }
  //         if (err) {
  //             if (err.code == 16) {
  //                 this.$router.push("./login");
  //             } else {
  //                 this.$message.error(err.errmsg);
  //             }
  //         }
  //     });
  // }
  // 停用、启用
  private stopOrStartAssignRuleAction(id: number, action: number) {
    this.dwAssignRule({
      id: Number(id),
      action: Number(action),
    });
  }
  // 删除
  private deleteAssignRuleAction(id: number) {
    this.dwAssignRule({
      id: Number(id),
      action: 3,
    });
  }
  // 启用停用和删除工用的处理参数、请求的函数
  private async dwAssignRule(options: any) {
    interface IDeleteTicketRecycleRuleReqOptions {
      id: number;
      action: number;
    }
    let _arg: IDeleteTicketRecycleRuleReqOptions = {
      id: Number(options.id),
      action: Number(options.action),
    };
    const { deleteTicketAssignRule }: any = await import(
      "@/request/deleteTicketAssignRule"
    );
    let response = await deleteTicketAssignRule(_arg, this);
    if (response && response.commonout) {
      if (response.commonout.code == 0) {
        this.$message({
          message: "success",
          type: "success",
        });
        if (options.action == 3) {
          let _item = this.resultData.find((item: any) => {
            if (item.id == options.id) {
              return item;
            }
          });
          arrRemove(this.resultData, _item);
        } else {
          this.resultData = this.resultData.map((item: any) => {
            // if(item.id == options.id) {
            // }
            item.attrs.workstatus =
              item.id == options.id
                ? item.attrs.workstatus == 1
                  ? 0
                  : 1
                : item.attrs.workstatus;
            return item;
          });
        }
      } else {
        this.$message({
          message: response.commonout.errmsg,
          type: "error",
        });
      }
    }
  }
  private saveTicketAssignRule() {
    let moment =
      this.form.moment &&
      this.form.moment.getHours() + ":" + this.form.moment.getMinutes();
    let request: any = new SaveTicketAssignRuleReq();
    let saveItem: any = new TicketAssignRuleAttr();
    if (this.showTimeType == "时间点") {
      saveItem.setAssigntime(this.formatTime(this.form.moment));
    }
    if (this.showTimeType == "时间段") {
      saveItem.setBegintime(
        this.form.period && this.formatTime(this.form.period[0])
      );
      saveItem.setEndtime(
        this.form.period && this.formatTime(this.form.period[1])
      );
      saveItem.setTimeaction(Number(this.form.actionValue));
    }
    saveItem.setTicketattrList(this.form.combValue);
    saveItem.setSortticketList(this.form.sortTicketValue);
    saveItem.setSortadminList([this.form.sortAdminValue]);
    saveItem.setAssignmodeList([this.form.assignModeValue]);
    saveItem.setAdminattrList(this.form.roleGroupValue);
    saveItem.setLoadattrList(this.form.loadAttrValue);
    saveItem.setUserattrList(this.form.roleGroupNewValue);
    saveItem.setName(this.form.name);
    saveItem.setIsfinal(Number(this.form.IsFinal));
    saveItem.setWorkday(this.form.WorkDay);
    // request.setAiscore(
    //   this.form.Aiscorerange1 + " - " + this.form.Aiscorerange2 + ""
    // );
    // request.setAistatus(this.form.Aistatus);
    request.setCommonin(setCommon());
    request.setId(this.isEditId);
    request.setData(saveItem);
    ticketClient.saveTicketAssignRule(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          if (!data.commonout || data.commonout.code == 0) {
            this.isEditName = false;
            this.isEditId = 0;
            this.resetForm();
            this.getTicketAssignRules();
            this.$message({
              message: "submit successfully",
              type: "success",
            });
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }

  private formatTime(time: Date | null): any {
    if (time) {
      return addZero(time.getHours()) + ":" + addZero(time.getMinutes());
    } else {
      return time;
    }
  }

  private setAttrItem(arr: any, value: string[] | number[], func: string) {
    let newArr: any = [];
    if (value) {
      if (typeof value == "string") {
        arr.forEach((i: any) => {
          if (value == i.value) {
            newArr.push(i);
          }
        });
      } else {
        value.forEach((item: string | number) => {
          arr.forEach((i: any) => {
            if (item == i.value) {
              newArr.push(i);
            }
          });
        });
      }
      newArr.forEach((item: any, index: number) => {
        let attrItem: any = new AttrItem();
        attrItem.setAttrid(item.attrid);
        attrItem.setName(item.name);
        attrItem.setValue(item.value);
        this.attr[func](attrItem, index);
      });
    }
  }

  private findSelectedValue(arr: any): string[] {
    let newArr: string[] = [];
    if (arr) {
      arr.forEach((item: any) => {
        if (item.value) {
          newArr.push(item.value);
        }
      });
    }
    return newArr;
  }

  // 试算页面
  private goAssignTrailCalcPage(row: any) {
    let rolename = [];
    for (let item of this.roleGroupList) {
      for (let i in row.attrs.adminattrList) {
        if (item.id == row.attrs.adminattrList[i]) {
          rolename.push(item.name);
        }
      }
    }
    let routeData: any = this.$router.resolve({
      path: "assignTryCalc",
      query: {
        id: row.attrs.id,
        rolenames: rolename.join(","),
      },
    });
    window.open(routeData.href, "_blank");
  }

  //  点击试算
  private tryAssign(row: any) {
    let rolename = [];
    for (let item of this.roleGroupList) {
      for (let i in row.attrs.adminattrList) {
        if (item.id == row.attrs.adminattrList[i]) {
          rolename.push(item.name);
        }
      }
    }
    this.rolenames = rolename.join(",");
    this.rule_id = row.attrs.id;
    this.showDialogType = 1;
    // this.searchUser();
  }

  private params() {
    let _arg: any = {
      Ruleid: this.rule_id,
    };
    if (this.ruleForm.createTimeRange && this.ruleForm.createTimeRange[0]) {
      _arg.Timerange =
        timeFormat(this.ruleForm.createTimeRange[0]) +
        " - " +
        timeFormat(this.ruleForm.createTimeRange[1]);
    }
    return _arg;
  }

  //获取试算数据
  private async getTryAssignData() {
    if (this.testRuleForm()) {
    } else {
      return;
    }
    this.isTryCalcDone = true;
    const {
      getTicketAssignTryCalcReq,
      getAssignTicketTrialCalcRequest,
    }: any = await import("@/request/getTicketAssign");
    let res = await getAssignTicketTrialCalcRequest.handleHttp(
      getTicketAssignTryCalcReq(this.params()),
      this
    );
    if (res && res.right) {
      this.tryCalcList = res.detailList;
      this.tryCalcData.total = res.total;
      this.tryCalcData.remain = res.remain;
      // this.pagerCount = res.pageout.total;
    } else {
      errorMsg(res.commonout.errmsg);
    }
    this.isTryCalcDone = false;
  }

  private closeDialog() {
    // if (this.showDialogType === 2) {
    //   this.resetForm("principalForm");
    // } else if (this.showDialogType === 3) {
    //   this.resetForm("penaltyForm");
    // }
    this.tryCalcList = [];
    this.tryCalcData = {
      total: 0,
      remain: 0,
    };
    this.showDialogType = 0;
  }

  // lee 搜索操作的判断
  private testRuleForm(): boolean {
    if (
      this.ruleForm.createTimeRange &&
      this.ruleForm.createTimeRange.length > 0
    ) {
      return true;
    } else {
      this.$message.error("Please choose the time");
      return false;
    }
  }
}
